/**
 * 日文专版打包：固定日文、隐藏语言切换与部分导航/功能。
 * 设置环境变量 `VUE_APP_JP_ONLY_BUILD=true`：
 * - 本地调试：`npm run serve:jp`
 * - 生产构建：`npm run build:jp`
 * - K8s/GitLab SaaS 测试：打 tag 如 `test-20210520-1111`（匹配 `test-*`）走 `ci/k8s_test.yml`，Docker 内执行 `npm run build:test`
 * - K8s/GitLab 正式：打 tag 如 `v1.0.0-jp`（匹配 `v*-jp`）走 `ci/k8s_release_jp.yml`，Docker 内执行 `npm run build:jp`
 *
 * 测试环境 SaaS 包可在「开发调试」中开关模拟日文专版（localStorage `debug:jp-only-build`），刷新后生效。
 */
import { IS_PRIVATE } from './env'

/** localStorage：测试环境 SaaS 包模拟日文专版（值为 `1`） */
export const JP_ONLY_BUILD_DEBUG_STORAGE_KEY = 'debug:jp-only-build'

function readJpOnlyBuildDebugOverride (): boolean {
  if (typeof localStorage === 'undefined') {
    return false
  }
  try {
    return localStorage.getItem(JP_ONLY_BUILD_DEBUG_STORAGE_KEY) === '1'
  } catch {
    return false
  }
}

/**
 * 是否按日文专版运行：页面加载时读 localStorage 模拟，无则读构建环境变量。
 * 业务侧统一用本常量，无需再区分 debug / env。
 */
export const IS_JP_ONLY_BUILD =
  readJpOnlyBuildDebugOverride() || process.env.VUE_APP_JP_ONLY_BUILD === 'true'

/** dev-debug 开关读写 localStorage */
export function isJpOnlyBuildDebugOverride (): boolean {
  return readJpOnlyBuildDebugOverride()
}

export function setJpOnlyBuildDebugOverride (enabled: boolean): void {
  if (typeof localStorage === 'undefined') {
    return
  }
  try {
    if (enabled) {
      localStorage.setItem(JP_ONLY_BUILD_DEBUG_STORAGE_KEY, '1')
    } else {
      localStorage.removeItem(JP_ONLY_BUILD_DEBUG_STORAGE_KEY)
    }
  } catch {
    // ignore
  }
}

/**
 * 双因素认证（MFA）启用条件：私有化部署或日文专版。
 * 登录表单/登录服务/管理员账户编辑弹窗等处统一引用此导出，勿在各处重复定义。
 */
export const ENABLE_MFA = IS_PRIVATE || IS_JP_ONLY_BUILD

/** 日文专版全局字体栈 */
export const JP_ONLY_FONT_FAMILY = "'BIZ UDPGothic', sans-serif"

/** 相对标准版（14px 基准）的字号缩减量，用于 BIZ UDPGothic 视觉对齐 */
export const JP_ONLY_FONT_SIZE_OFFSET_PX = 2
